var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-footer mts-container"},[_c('span',[_vm._v(_vm._s(_vm.place))]),_c('span',[_vm._v(_vm._s(_vm.desc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }